import * as Yup from "yup";
import {NormalizedROriginProject } from "slices/rOriginProject/rOriginProjectState";

const REQUIRED_MESSAGE = "A dataset name is required.";
const MAX_NAME_MESSAGE = "Max field length is 250 characters";

export interface RefrenceProjectDto {
  name: string | undefined;
  label: string | undefined;
}

export type CreateCompositeProjectFormModel = {
  name: string;  
  refrenceProject: RefrenceProjectDto[];
  mergedProject: NormalizedROriginProject[];

};

export const CreateCompositeProjectFormSchema = Yup.object({
  name: Yup.string().required(REQUIRED_MESSAGE).max(250, MAX_NAME_MESSAGE).nullable(false),
  refrenceProject: Yup.array().of(
    Yup.object({
      name: Yup.string().required(REQUIRED_MESSAGE),
      label: Yup.string().required(REQUIRED_MESSAGE),
    })
  ).min(1, "Select at least one reference dataset").nullable(false),
  mergedProject: Yup.array().of(
    Yup.object({
      name: Yup.string().required(REQUIRED_MESSAGE),
      label: Yup.string().required(REQUIRED_MESSAGE),
    })
  ).min(1, "Select at least one dataset to merge").nullable(false),
}).defined();

export const initialCreateStackForm: CreateCompositeProjectFormModel = { 
  name: "",
  refrenceProject: [], 
  mergedProject:[], 
 
};
